let editorStyles = [];

export const registerEditorStyles = (newStyle) => {
  editorStyles.push(newStyle);
};

export const getEditorStyles = () => {
  return editorStyles;
};
